import TableAHSF from "../../../../Components/TableAHSF";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PracticalExperiencesForm from "./PracticalExperiencesForm";
import { DeleteWorkExperience } from "../../../../Redux/Reducers/Submitter/WorkExperience";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";
import PopupAHSF from "../../../../Components/PopupAHSF";
import DraggableTable from "../../../../Components/TableAHSF/TableAHSFDragDrop";
import TableAHSFF from "../../../../Components/TableAHSF/TableAHSFDragDrop";
const PracticalExperiencesTable = (props) => {
  const navigate = useNavigate();
   const {ApplicationInformationId} = useParams();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [workExperienceId, setWorkExperienceId] = useState(null);
  const dispatch = useDispatch();
  const [PopupComponentStatus, SetPopupComponentStatus] = useState(false);
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const lang = useSelector((state) => state.languageReducer.Language);
 const state = useSelector((state) => {
    return {
      ActiveRound: state.ApplicationInformation.ActiveRound,
     
    };
  });
  const RequestAccessor = [
    {
      KeyName: "jobTitle",
      ShowStatus: true,
      NmaeColumn: "المسمى الوظيفي",
      NmaeColumnEN: "Job title",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "organization",
      ShowStatus: true,
      NmaeColumn: "الجهة (المؤسسة/الجامعة)",
      NmaeColumnEN: "Organization (Institution/University)",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "timePeriodFromNumber",
      ShowStatus: true,
      NmaeColumn: "الفترة من سنة",
      NmaeColumnEN: "Period From Year",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    ,
    {
      KeyName: "timePeriodToNumber",
      ShowStatus: true,
      NmaeColumn: " الفترة الى سنة",
      NmaeColumnEN: "Period To Year",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    ,
    {
      KeyName: "natureOfWork",
      ShowStatus: true,
      NmaeColumn: "طبيعة العمل",
      NmaeColumnEN: "Nature of Work",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];

  

  const OtherMainBtns = [
    {
      Click: async (e) => {
        let data = JSON.parse(e.target.value);
        setWorkExperienceId(data.workExperienceId);
        setPopUpBodyStatus(true);
      },

      content: "",
      className: props.disabled ? "bi bi-eye-fill" : "bi bi-pencil-fill",
      id: "editBtn",
      title: "عرض الطلب",
      ShowStatus: true,
      ShowHideBtn: [],
    },
    {
      Click: async (e) => {
        let data = JSON.parse(e.target.value);

        Swal.fire({
          title:
            lang == "ar"
              ? "  هل انت متأكد من الحذف ؟"
              : "Are you sure you want to delete?",
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: lang == "ar" ? "تأكيد" : "Confirmed",
          cancelButtonText: lang == "ar" ? "إلغاء" : "Cancel",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            var result = await dispatch(
              DeleteWorkExperience({ workExperienceId: data.workExperienceId })
            );
            if (result.payload.code == 200) {
              Swal.fire({
                position: "center",
                icon: "success",
                title:
                  lang == "ar"
                    ? "تم حفظ المعلومات بنجاح"
                    : "Saved Successfully",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              dispatch(setRefreshTable({ tableId: "WorkExperience" }));
            }
          }
        });
      },

      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف الطلب",
      ShowStatus: !props.disabled,
      ShowHideBtn: [],
    },
  ];
  const closePopupComponent = () => {
    console.log("zazazaz");
    
    SetPopupComponentStatus(false);
  };
  const RequestsColumns = [];
  const PopupOPjectData = {
    openPopupState: PopupComponentStatus,
    isPopupOpenStatus: PopupComponentStatus,
    isPopupOpenFunction: closePopupComponent,
    componentBody: (
      <div>
        <PracticalExperiencesForm
          setRefreshDataFromClosePagePracticalExperiences={
            props.setRefreshDataFromClosePagePracticalExperiences
          }
          refreshDataFromClosePagePracticalExperiences={
            props.refreshDataFromClosePagePracticalExperiences
          }
          FormStatus={"Add"}
          closePopupComponent={closePopupComponent}
        />
      </div>
    ),
    maxWidth: "600px",
    maxHeight: "600px",
    titleEN: "Practical Experiences",
    title: lang == "ar" ? "الخبرات العملية" : "Practical experience",
  };
  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: (
      <PracticalExperiencesForm
        setRefreshDataFromClosePagePracticalExperiences={
          props.setRefreshDataFromClosePagePracticalExperiences
        }
        refreshDataFromClosePagePracticalExperiences={
          props.refreshDataFromClosePagePracticalExperiences
        }
        workExperienceId={workExperienceId}
        FormStatus={"Edit"}
        closePopupComponent={closePopupComponent}
        disabled={props.disabled}
      />
    ),

    title: "",
    maxWidth: "600px",
    maxHeight: "600px",
    idssss: "SecondarySectors",
    titleEN: "Practical Experiences",
    title: lang == "ar" ? "الخبرات العملية" : "Practical experience",
  };
  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        refreshDataFromClosePagePracticalExperiences={
          props.refreshDataFromClosePagePracticalExperiences
        }
        setRefreshDataFromClosePagePracticalExperiences={
          props.setRefreshDataFromClosePagePracticalExperiences
        }
        tableId="WorkExperience"
        lang={localStorage.getItem("lang")}
        uniqueValue={""}
        valueButtonAction={""}
        URL={`api/WQ_NT_WE_WorkExperience/GetWQ_NT_WE_WorkExperienceList`}
        UrlBody={{
          applicationInformationId: localStorage.getItem(
            "ApplicationInformationId"
          )||
          ApplicationInformationId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الخبرات العملية"}
        titelTableEN={"Practical experience"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={!props.disabled}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        hideIconsAction={true}
        checkBoks={false}
        nameColumAction=""
        showIconsApplication={true}
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            // title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
            titleEN={popUpBody.titleEN}
            title={popUpBody.title}
          />
        }
      />
    </>
  );
};
export default PracticalExperiencesTable;
